import type { loader as rootLoader } from '#app/root.js'
import { useRouteLoaderData } from '@remix-run/react'
import { z } from 'zod'

export const userEmailSchema = z.string().email()
export const userPasswordSchema = z.string().min(8).max(100)

export function useOptionalUser() {
	const data = useRouteLoaderData<typeof rootLoader>('root')
	return data?.user ?? null
}

export function useUser() {
	const maybeUser = useOptionalUser()
	if (!maybeUser) throw new Error('User not found')
	return maybeUser
}
